import { FC, ReactNode } from 'react';
import XhtmlText from '../XhtmlText';
import { XhtmlTextBlockResponse } from '../types/blocks';

interface IXhtmlTextBlock {
  xhtmlTextBlockResponse: XhtmlTextBlockResponse;
}

const XhtmlTextBlock: FC<IXhtmlTextBlock> = ({ xhtmlTextBlockResponse }): ReactNode => {
  return <XhtmlText xhtmlResponse={xhtmlTextBlockResponse.xhtmlTexten} />;
};

export default XhtmlTextBlock;
